module.exports = __webpack_public_path__ + "static/img/platinum.929cf6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/platinum.png
// module id = K2qY
// module chunks = 35